import { render, staticRenderFns } from "./WhatIsSection.vue?vue&type=template&id=240f15d6"
import script from "./WhatIsSection.vue?vue&type=script&lang=js"
export * from "./WhatIsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports